import http from './base-http-service';

const API_URL = 'notification-api/v1/notification';
export const getNotifications = async (convocationId, petitionId, params) => {
    return await http.get(`${API_URL}/${convocationId}/${petitionId}/getNotifications?${params}`);
}

export const getNotificationDetailAndRead = async (convocationId, petitionId, notificationId) => {
    return await http.put(`${API_URL}/${convocationId}/${petitionId}/getAndReadNotification/${notificationId}`);
}
export const getNotificationById = async (convocationId, notificationId) => await http.get(`${API_URL}/${convocationId}/${notificationId}`);
export const readNotification = async (convocationId, notificationId) => await http.post(`${API_URL}/${convocationId}/${notificationId}`);
